module.exports = __webpack_public_path__ + "img/Bulgaria.4bcc359e.png";